"use strict";
// Auto-generated index file
// This file exports all generated TypeScript interfaces
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoIndexDocumentModel = exports.LuaAPILibraryIndexDocumentModel = exports.LuaAPIGlobalIndexDocumentModel = exports.LuaAPIEnumIndexDocumentModel = exports.LuaAPIDataTypeIndexDocumentModel = exports.LuaAPIClassIndexDocumentModel = exports.DevForumIndexDocumentModel = exports.CloudAPIV2IndexDocumentModel = exports.CloudAPIV1IndexDocumentModel = exports.CloudAPILegacyIndexDocumentModel = exports.CloudAPIFeaturesIndexDocumentModel = exports.CloudAPISchemaIndexDocumentModel = exports.ArticleIndexDocumentModel = exports.GeneralIndexDocumentModel = void 0;
const GeneralIndexDocumentModel = __importStar(require("./generated/GeneralIndexDocumentModel"));
exports.GeneralIndexDocumentModel = GeneralIndexDocumentModel;
const ArticleIndexDocumentModel = __importStar(require("./generated/ArticleIndexDocumentModel"));
exports.ArticleIndexDocumentModel = ArticleIndexDocumentModel;
const CloudAPISchemaIndexDocumentModel = __importStar(require("./generated/CloudAPISchemaIndexDocumentModel"));
exports.CloudAPISchemaIndexDocumentModel = CloudAPISchemaIndexDocumentModel;
const CloudAPIFeaturesIndexDocumentModel = __importStar(require("./generated/CloudAPIFeaturesIndexDocumentModel"));
exports.CloudAPIFeaturesIndexDocumentModel = CloudAPIFeaturesIndexDocumentModel;
const CloudAPILegacyIndexDocumentModel = __importStar(require("./generated/CloudAPILegacyIndexDocumentModel"));
exports.CloudAPILegacyIndexDocumentModel = CloudAPILegacyIndexDocumentModel;
const CloudAPIV1IndexDocumentModel = __importStar(require("./generated/CloudAPIV1IndexDocumentModel"));
exports.CloudAPIV1IndexDocumentModel = CloudAPIV1IndexDocumentModel;
const CloudAPIV2IndexDocumentModel = __importStar(require("./generated/CloudAPIV2IndexDocumentModel"));
exports.CloudAPIV2IndexDocumentModel = CloudAPIV2IndexDocumentModel;
const DevForumIndexDocumentModel = __importStar(require("./generated/DevForumIndexDocumentModel"));
exports.DevForumIndexDocumentModel = DevForumIndexDocumentModel;
const LuaAPIClassIndexDocumentModel = __importStar(require("./generated/LuaAPIClassIndexDocumentModel"));
exports.LuaAPIClassIndexDocumentModel = LuaAPIClassIndexDocumentModel;
const LuaAPIDataTypeIndexDocumentModel = __importStar(require("./generated/LuaAPIDataTypeIndexDocumentModel"));
exports.LuaAPIDataTypeIndexDocumentModel = LuaAPIDataTypeIndexDocumentModel;
const LuaAPIEnumIndexDocumentModel = __importStar(require("./generated/LuaAPIEnumIndexDocumentModel"));
exports.LuaAPIEnumIndexDocumentModel = LuaAPIEnumIndexDocumentModel;
const LuaAPIGlobalIndexDocumentModel = __importStar(require("./generated/LuaAPIGlobalIndexDocumentModel"));
exports.LuaAPIGlobalIndexDocumentModel = LuaAPIGlobalIndexDocumentModel;
const LuaAPILibraryIndexDocumentModel = __importStar(require("./generated/LuaAPILibraryIndexDocumentModel"));
exports.LuaAPILibraryIndexDocumentModel = LuaAPILibraryIndexDocumentModel;
const VideoIndexDocumentModel = __importStar(require("./generated/VideoIndexDocumentModel"));
exports.VideoIndexDocumentModel = VideoIndexDocumentModel;
// Export all types for easy access
__exportStar(require("./generated/GeneralIndexDocumentModel"), exports);
//# sourceMappingURL=index.js.map